import { Button, Space, Table, Tag, Tooltip } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import './houseTable.css'
import DeleteModal from '../deleteModal/deleteModal'
import ChangePriority from '../changePriority/changePriority'
import { useEffect, useState } from 'react'
import { forwardRef } from 'react'
import { useImperativeHandle } from 'react'
import HouseRecommend from '../recommend/recommend'
import moment from 'moment'
import SwitchStatus from '../recommendAD/recommendAD'
import RecommendAD from '../recommendAD/recommendAD'
import Prioritized from '../prioritized/prioritized'

const HouseTable = forwardRef((props, ref) => {
  const columns = [
    {
      title: '房源编号',
      dataIndex: 'sn',
      key: 'sn',
      width: 100,
    },
    {
      title: '房源标题',
      dataIndex: 'title',
      key: 'title',
      width: 250,
      ellipsis: {
        showTitle: false,
      },
      render: (title) => (
        <Tooltip placement="topLeft" title={title}>
          {title}
        </Tooltip>
      ),
    },
    {
      title: '已订量',
      dataIndex: 'room_remain',
      key: 'room_remain',
      width: 100,
    },
    {
      title: '区域',
      key: 'regionsName',
      dataIndex: 'regionsName',
      width: 200,
      ellipsis: {
        showTitle: false,
      },
      render: (regionsName) => (
        <Tooltip placement="topLeft" title={regionsName}>
          {regionsName}
        </Tooltip>
      ),
    },
    {
      title: '上架状态',
      key: 'isshow',
      dataIndex: 'isshow',
      width: 100,
    },
    {
      title: '首页推荐',
      key: 'isrecommend',
      dataIndex: 'isrecommend',
      width: 100,
    },
    {
      title: '优先级',
      key: 'priority',
      dataIndex: 'priority',
      width: 100,
    },
    {
      title: '广告推荐',
      key: 'recommendAD',
      dataIndex: 'recommendAD',
      width: 100,
    },
    {
      title: '推荐排序',
      key: 'prioritized',
      dataIndex: 'prioritized',
      width: 100,
    },
    {
      title: '类型',
      dataIndex: 'typeContent',
      key: 'typeContent',
      width: 150,
    },
    // 废弃
    // {
    //   title: '房间数',
    //   key: 'roomsName',
    //   dataIndex: 'roomsName',
    //   width: 100,
    // },
    {
      title: '租金',
      key: 'price',
      dataIndex: 'price',
      width: 100,
    },

    {
      title: '发布时间',
      key: 'createdAt',
      dataIndex: 'createdAt',
      width: 200,
      ellipsis: {
        showTitle: false,
      },
      render: (launch_time) => (
        <Tooltip placement="topLeft" title={launch_time}>
          {launch_time}
        </Tooltip>
      ),
    },

    {
      title: '操作',
      key: 'action',
      width: 380,
      fixed: 'right',
      render: (_, record) => (
        <Space size="middle">
          <a onClick={() => jumpToEditor(record)}>编辑</a>
          <DeleteModal id={record.id} setData={setHouseList} />
          <ChangePriority id={record.id} setIsFresh={setIsFresh} />
          <HouseRecommend
            id={record.id}
            is_recommend={record.is_recommend}
            setIsFresh={setIsFresh}
          />
          <RecommendAD
            id={record.id}
            value={record.is_recommend_ad}
            setIsFresh={setIsFresh}
            name="is_recommend_ad"
          />
          <Prioritized
            id={record.id}
            value={record.is_prioritized}
            setIsFresh={setIsFresh}
            name="is_prioritized"
          />
        </Space>
      ),
    },
  ]
  const setIsFresh = props.setIsFresh //刷新组件
  const [houseList, setHouseList] = useState([])
  const [houseDetail, setHouseDetail] = useState({})
  let navigate = useNavigate()

  const jumpToNew = () => {
    navigate('/newHouse', { state: { state: 'new' } })
  }
  const jumpToEditor = (info) => {
    //将本列的详细数据传递给编辑页面
    navigate('/newHouse', { state: { state: 'edit', info: info } })
  }
  //将优先级数字转化成文字
  const swicthPriority = (num) => {
    switch (num) {
      case 0:
        return '未推荐'
        break
      case 1:
        return '已推荐'
        break
      default:
        break
    }
  }
  //将上架状态数字数字转化成文字
  const swicthshow = (num) => {
    switch (num) {
      case 0:
        return '未上架'
      case 1:
        return '已上架'
      default:
        break
    }
  }
  //将上架状态数字数字转化成文字
  const switchRecommendAD = (num) => {
    switch (num) {
      case 0:
        return '不参与'
      case 1:
        return '参与'
      default:
        break
    }
  }
  //将上架状态数字数字转化成文字
  const switchPrioritized = (num) => {
    switch (num) {
      case 0:
        return '未优先'
      case 1:
        return '优先'
      default:
        break
    }
  }
  //将房源类型数字数字转化成文字
  const switchType = (num) => {
    switch (num) {
      case 1:
        return '超豪华别墅'
      case 2:
        return '距学校超级近'
      case 3:
        return '超高性价比'
      default:
        break
    }
  }

  //将区域数字转化成文字
  const switchRegionsName = (num) => {
    const res = []
    num.map((item, index) => {
      switch (item) {
        case 1:
          res.push('Cannon Park Region')
          break
        case 2:
          res.push('Charter Avenue')
          break
        case 3:
          res.push('Sir Henry Parkes Road')
          break
        case 4:
          res.push('White Willow Park')
          break
        case 5:
          res.push('Torrington Avenue')
          break
        case 6:
          res.push('others')
          break
        default:
          break
      }
    })
    const regions = res.join('、')
    // console.log(finalres);
    return regions
  }

  //将上架状态数字数字转化成文字
  const switchroomsName = (num) => {
    switch (num) {
      case 1:
        return '1间'
      case 2:
        return '2间'
      case 3:
        return '3间'
      case 4:
        return '4间'
      case 5:
        return '5间'
      case 6:
        return '6间'
      case 7:
        return '7间'
      case 8:
        return '8间'
      case 9:
        return '9间'
      default:
        return ' - '
    }
  }
  const changeTable = (data) => {
    data.map((info, index) => {
      info.key = index
      info.isrecommend = swicthPriority(info.is_recommend)
      info.isshow = swicthshow(info.is_show)
      info.createdAt = moment(info.created_at).format('YYYY-MM-DD HH:mm:ss')
      info.regionsName = switchRegionsName(info.regions)
      info.roomsName = switchroomsName(info.rooms_actual)
      info.typeContent = switchType(info.type)
      info.recommendAD = switchRecommendAD(info.is_recommend_ad)
      info.prioritized = switchPrioritized(info.is_prioritized)
      info.room_remain = info.rooms_remaining + '/' + info.rooms_actual
      return info
    })
    console.log(data)
    setHouseList(data)
  }
  useImperativeHandle(ref, () => ({
    changeTable,
  }))
  return (
    <div style={{ marginBottom: '20px' }}>
      <div className="newHouse">
        <Button
          // style={{
          //   position: "absolute",
          //   top: "16vw",
          //   right: "5vw",
          // }}
          style={{ float: 'right', marginBottom: '10px' }}
          icon={<PlusOutlined />}
          type="primary"
          onClick={jumpToNew}
        >
          新建{' '}
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={houseList}
        pagination={false}
        scroll={{
          x: 2200,
          // y: 300,
        }}
        onRow={(record) => {
          return {
            onClick: (event) => {
              setHouseDetail(record)
            }, // 点击行
            // onDoubleClick: event => {},
            // onContextMenu: event => {},
            // onMouseEnter: event => {}, // 鼠标移入行
            // onMouseLeave: event => {},
          }
        }}
      />
    </div>
  )
})

export default HouseTable
